import React from "react";
import img from "../../Images/Group (4).png";
import img2 from "../../Images/Group 1171279366 (2).png";
const WhyChooseUs = () => {
  const cards = [
    {
      title: "Real-Time Property Data Updates",
      description:
        "1.We deliver real-time property data sourced directly from verified owners, agents, and builders across Gurgaon, Noida, and South Delhi. Our data is updated daily so you never miss new listings, property leads, or investor opportunities.",
    },
    {
      title: "100% Accurate & Verified Property Information",
      description:
        "2.Every property listing in our database goes through a multi-level verification process to ensure you get only authentic and accurate property information — helping you save time and focus on closing deals faster.",
    },
    {
      title: "Personalized Locality-Wise Solutions",
      description:
        "3.Whether you deal in luxury apartments in South Delhi or residential plots in Noida Extension, our platform offers customized, area-specific data. This helps you target the right buyers and sellers within your preferred localities.",
    },
    {
      title: "Verified Owner, Buyer & Dealer Contacts",
      description:
        "4.Access a large collection of verified phone numbers and contact details of property owners, dealers, and investors. Every contact is validated, ensuring higher conversion rates and genuine business growth.",
    },
    {
      title: "Flexible & Affordable Subscription Plans",
      description:
        "5.Choose from monthly, quarterly, or yearly subscription plans designed for real estate agents, brokers, and property consultants. Pay only for the data you need and scale as your business grows.",
    },
    {
      title: "Expert Support & Data Assistance",
      description:
        "6.Our dedicated support team is always available to help you with data setup, customization, and real-time query resolution — making your subscription experience smooth and result-driven.",
    },
  ];
  return (
    <section className="why_choose_us_section">
      <h1>Why Choose Us</h1>
      <div className="why_choose_us_card_wrapper">
        {cards.map((e, i) => {
          return (
            <>
              <div className="why_card">
                <div className="card_img">
                  <img src={img} />
                </div>
                <p className="perfect_para">{e?.title}</p>
                <p className="perfect_para2">{e?.description}</p>
              </div>
            </>
          );
        })}
      </div>
      <img className="img_bg" src={img2} />
    </section>
  );
};

export default WhyChooseUs;
